export function tableLabels() {

    console.log('Test');

    var checkExist = setInterval(function() {
        if ($('.question-type-table').length > 0) {
            clearInterval(checkExist);

            $('body').addClass('table-block')

            // Clear labels when adding a new table row
            $('.js-dyno-table-labels').remove();
            $('.question-type-table').each(function(){    

                // Loop through the headers
                var tableHeader = [];
                $(this).find('thead tr th').each(function(){
                    //console.log('This is: ' + $(this).text());
                    tableHeader.push($(this).text());
                });

                // Append to each table row
                $(this).find('tbody tr').each(function(){
                    $(this).find('td').each(function(i){
                        //if (tableHeader[i] !== 'Action' && tableHeader[i].toLowerCase().indexOf("start date") === -1 && tableHeader[i].toLowerCase().indexOf("end date") === -1 ) {
                        if (tableHeader[i] !== 'Action') {
                            $(this).prepend(`<label class="js-dyno-table-labels">${tableHeader[i]}</label>`);
                        }
                    });
                });
            });

            // Add mondatory sr class
            $('.forms-mandatory').each(function(){
                $(this).after(
                    `
                        <span class="sr-only"> (Required) </span</span> 
                    `
                )
            });
        }
    }, 100); // check every 100ms
}